(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/poy-score-calculator/assets/javascripts/poy-score-calculator.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/poy-score-calculator/assets/javascripts/poy-score-calculator.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _svs$poker_react$comp = svs.poker_react.components,
  PokerPaper = _svs$poker_react$comp.PokerPaper,
  DialogContextual = _svs$poker_react$comp.DialogContextual;
const _svs$ui$reactForm = svs.ui.reactForm,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Input = _svs$ui$reactForm.Inputv2,
  Form = _svs$ui$reactForm.Form;
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
const calculateScore = (n, p, b) => Math.round(10 * Math.sqrt(n / p) * (0.5 + 0.5 * Math.log(b)));
const twentyPercent = 0.2;
const PoyScoreCalculator = () => {
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    buyInCost = _useState2[0],
    setBuyInCost = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    nPlayers = _useState4[0],
    setNPlayers = _useState4[1];
  const _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    finishingPosition = _useState6[0],
    setFinishingPosition = _useState6[1];
  const _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    calculatedScore = _useState8[0],
    setCalculatedScore = _useState8[1];

  const dialog = 'Rankingpoängen räknas fram med formeln 10*[Sqrt(N/P)]*[0.5+0.5*Ln(B)] där N = Deltagare i turneringen, P = Placering i turneringen och B = Inköp exkl. turneringsavgift. Observera att endast de bästa 20% får poäng.';
  useEffect(() => {
    if (nPlayers && buyInCost && finishingPosition && parseInt(finishingPosition, 10) / parseInt(nPlayers, 10) <= twentyPercent) {
      setCalculatedScore("".concat(calculateScore(parseInt(nPlayers, 10), parseInt(finishingPosition, 10), parseInt(buyInCost, 10))));
    } else {
      setCalculatedScore(null);
    }
  }, [nPlayers, finishingPosition, buyInCost]);
  const validateInput = (value, stateFunction) => {
    if (value && parseInt(value, 10) || value === '') {
      stateFunction(parseInt(value, 10) ? parseInt(value, 10) : '');
    }
  };
  return React.createElement("section", {
    className: "poy-score-wrapper margin-top-4"
  }, React.createElement("h2", {
    className: "h2 center-text poy-score-calculator-header"
  }, React.createElement("span", null, "R\xE4kna ut dina rankingpo\xE4ng"), React.createElement(DialogContextual, {
    ariaLabel: "L\xE4s mer om hur rankingpo\xE4ngen r\xE4nkas ut",
    dialog: dialog
  })), React.createElement("p", {
    className: "center-text"
  }, "Fyll i formul\xE4ret och ta reda p\xE5 vilken po\xE4ng du f\xE5r vid olika placeringar."), React.createElement(PokerPaper, {
    className: "poy-score-calculator"
  }, React.createElement(Form, null, React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(Input, {
    autoComplete: "off",
    inverted: true,
    label: "Ink\xF6p",
    name: "buyIn",
    onChange: e => validateInput(e.target.value, setBuyInCost),
    type: "text",
    value: buyInCost
  }), React.createElement(Input, {
    autoComplete: "off",
    inverted: true,
    label: "Antal spelare",
    name: "nPlayers",
    onChange: e => validateInput(e.target.value, setNPlayers),
    type: "text",
    value: nPlayers
  }), React.createElement(Input, {
    autoComplete: "off",
    inverted: true,
    label: "Slutplacering",
    name: "finishingPosition",
    onChange: e => validateInput(e.target.value, setFinishingPosition),
    type: "text",
    value: finishingPosition
  }))), React.createElement("div", {
    className: "calctulated-score-result"
  }, React.createElement("p", {
    className: "center-text final-score-header"
  }, "Rankingpo\xE4ng"), React.createElement("p", {
    className: "center-text final-score h3"
  }, calculatedScore ? calculatedScore : '-'))));
};
setGlobal('svs.poker_react.components.PoyScoreCalculator', PoyScoreCalculator);

 })(window);